import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import FormNumberInput from "go-form/components/FormNumberInput";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<EmployeeApi>;
}

const EmployeeInformationForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		register,
	} = form;

	return (
		<fieldset className="form-group">
			<legend>
				<h5>{t("lib:common.word.informations")}</h5>
			</legend>
			<div className={"row"}>
				<div className="col-md-6">
					<FormNumberInput
						name="code"
						errors={errors}
						control={control}
						format={"######"}
						suffix={""}
						label={t("modules.employee.field.code.title")}
					/>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("modules.employee.field.card_code.title")}
						register={register}
						name="card_code"
						errors={errors}
					/>
				</div>
			</div>
		</fieldset>
	);
};

export default EmployeeInformationForm;
